module.exports = __webpack_public_path__ + "static/media/Falcon901_3c.68e57099.svg";